const ParseStringWithLinks = (text) => {
  // Regex to match bracketed text followed by a URL in parentheses
  const linkRegex = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;

  // Split the string into an array of text and matched links
  const parts = [];
  let lastIndex = 0;

  text.replace(linkRegex, (match, linkText, url, index) => {
    // Push preceding text before the match
    if (index > lastIndex) {
      parts.push(text.slice(lastIndex, index));
    }
    // Push the link as an object
    parts.push({ linkText, url });
    lastIndex = index + match.length;
    return match;
  });

  // Push any remaining text after the last match
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  // Map the parts into React elements
  return (
      parts.map((part, idx) => {
        if (typeof part === "string") {
          // Plain text
          return <span key={idx}>{part}</span>;
        } else {
          // Clickable link
          return (
            <a
              key={idx}
              href={part.url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => {
                e.stopPropagation(); // Prevents the parent div from detecting the click
              }}
            >
              {part.linkText}
            </a>
          );
        }
      })
  );
};

export default ParseStringWithLinks;
